import RangePairController from './range-pair';

export default class extends RangePairController {
    static values = {
        ...RangePairController.values,
        locale: { type: String, default: 'cs-CZ' },
    };

    /**
     * Converts an absolute month integer (year * 12 + month - 1)
     * into a localised "month year" label.
     */
    _formatValue(value) {
        const n = Number(value);
        const year = Math.floor(n / 12);
        const month = n % 12; // 0-based: 0 = January, 11 = December
        return new Date(year, month, 1)
            .toLocaleDateString(this.localeValue, { month: 'long', year: 'numeric' });
    }
}
